import { createUserWithEmailAndPassword, signInWithEmailAndPassword } from 'firebase/auth';
import React from 'react'
import { useRef } from 'react';
import { auth } from '../firebase';
import "./SignupScreen.css"

function SignupScreen() {
    const emailRef = useRef(null);
    const passwordRef = useRef(null);

    const register = (e) => {
e.preventDefault();
createUserWithEmailAndPassword(auth,
    emailRef.current.value,
    passwordRef.current.value)
    .then((authUser) => {
        console.log(authUser);
     })
    .catch((error) => {
alert(error.message)
    });
    }
const signIn = (e) => {
e.preventDefault();
signInWithEmailAndPassword(auth,
    emailRef.current.value,
    passwordRef.current.value )
    .then((authUser) => {
        console.log(authUser);
     })
    .catch((error) => {
alert(error.message)
    });
}
  return (
    <div className='signupScreen'>
      <form action="">
        <h1>Sign In</h1>
        <input ref={emailRef} type="email"  placeholder='Email'/>
        <input ref={passwordRef} type="password" placeholder='Password' />
        <button type='submit' onClick={signIn}> Sign In</button>

        <h4>
           <span className='signupScreen__gray'>New to Netflix? </span> 
             <span className='signupScreen__link' onClick={register}> Sign Up now.</span> </h4>

              {/* <h5 className='signupScreen__bottom'>This page is protected by Google reCAPTCHA to ensure you're not a bot</h5> */}
      </form>
    </div>
  )
}

export default SignupScreen
